module.exports = __webpack_public_path__ + "img/stock4.1788bac6.png";